import { Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useState } from "react";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";

interface AddWebinarRecordingProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
}

const AddWebinarRecording = ({ show, handleClose, data }: AddWebinarRecordingProps) => {
    const [isLoading, setLoading] = useState(false);
    const [learningData, setLearningData] = useState<any>([{ image: null, title: '', link: '' }]);

    const onSubmit = () => {

    }

    return (
        <>
            <Offcanvas show={show} onHide={() => {
                handleClose();
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{data ? 'Edit' : 'Add'}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="Past Glimpse">
                            {
                                learningData.map((learning: any, index: number) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("learningIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("learningIndex"));
                                            if (fromIndex === index) return;
                                            const newLearningData = [...learningData];
                                            const [moved] = newLearningData.splice(fromIndex, 1);
                                            newLearningData.splice(index, 0, moved);
                                            setLearningData(newLearningData);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            // uploadFile(file, index, 'PAST_GLIMPSE');
                                                        }
                                                    }}
                                                />
                                                {learningData[index] && (
                                                    <img
                                                        src={
                                                            learningData[index].image
                                                                ? learningData[index].image
                                                                : data?.learningData?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Title`}
                                                        value={learningData[index].title}
                                                        onChange={(e) => {
                                                            const newLearningData = [...learningData];
                                                            newLearningData[index].title = e.target.value;
                                                            setLearningData(newLearningData);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setLearningData([...learningData, { image: null, title: '', link: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {learningData.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newLearningData = learningData.filter((_: any, i: number) => i !== index);
                                                                setLearningData(newLearningData);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={`Link`}
                                                    value={learningData[index].link}
                                                    onChange={(e) => {
                                                        const newLearningData = [...learningData];
                                                        newLearningData[index].link = e.target.value;
                                                        setLearningData(newLearningData);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={onSubmit}
                    />
                </div>
            </Offcanvas>
        </>
    )
}

export default AddWebinarRecording;